import { get, post } from '../http-calls';

export const getLocationDetailsByID = async (id) => {
    let res = await get(`LocationDetails/${id}`, { useAuthToken: true });
    return res;
};

export const getLocationDetailsScreenDropdown = async () => {
    let res = await get('LocationDetails/Location_ScreenDropdown', { useAuthToken: true });
    return res;
};

export const postLocationDetails = async (data) => {
    let res = await post('LocationDetails', data, { useAuthToken: true });
    return res;
};
